import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { PmaController } from '@prlw/core/pma/pma.controller';
import { map } from 'rxjs';
import { TextMarqueeComponent, TItem } from './text-marquee.component';
import { FactItem } from '@prlw/core/pma/pma-gateway.interface';
import { formatPmaFactDateTime } from './format-pma-fact-datetime';

@Component({
  selector: 'prlw-text-marquee',
  imports: [AsyncPipe, TextMarqueeComponent],
  templateUrl: './text-marquee.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextMarqueeContainer {
  constructor(private readonly pmaController: PmaController) {}

  items$ = this.pmaController.facts$.pipe(
    map((facts): TItem[] =>
      facts
        .filter(
          (item): item is FactItem & { fact_title: string; fact_url: string } =>
            Boolean(item.fact_title) && Boolean(item.fact_url),
        )
        .map((item) => ({
          dateLabel:
            formatPmaFactDateTime(item.fact_published_at) ??
            formatPmaFactDateTime(item.fact_found_at),
          title: item.fact_title,
          url: item.fact_url,
          source: item.fact_search_source,
        })),
    ),
  );
}
